var _g, _g2, _g3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtomIconTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    stroke: "black",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 128 128)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 128,
    rx: 100,
    ry: 48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 128 128)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 128,
    rx: 100,
    ry: 48
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-60 128 128)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128,
    cy: 128,
    rx: 100,
    ry: 48
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 32,
    fill: "black",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 32,
    r: 20,
    fill: "black",
    stroke: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 148,
    r: 20,
    fill: "black",
    stroke: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 180,
    r: 20,
    fill: "black",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomIconTransparent);
export default __webpack_public_path__ + "static/media/atom_icon_transparent.b40c9009626da02a7875e1c9611f9e5c.svg";
export { ForwardRef as ReactComponent };